var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.293945H513V342.287H0V0.293945Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171.29L0 5.6582V49.9866L156.13 171.29L0 292.594V336.922L256.5 171.29Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.6582V336.922L189.587 171.29L0 5.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2699 128.567L69.2306 152.19L99.4104 135.748L84.6586 166.789L109.618 190.41L75.5398 185.971L60.7881 217.01L54.4798 183.228L20.4014 178.789L50.5792 162.349L44.2699 128.567Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.290039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTl);
export default __webpack_public_path__ + "static/media/TL.689f5b85beee1c263f205eb43e717d5b.svg";
export { ForwardRef as ReactComponent };